import DataMappingDetail from "./DataMappingDetail";

export default DataMappingDetail;
